import MenuRow, { MenuItem } from "./MenuRow";
import styles from "./menuPanel.module.scss";

interface MenuPanelProps {
  items: MenuItem[];
  width?: number | "hug";
  className?: string;
}

export default function MenuPanel({ items, width = 200, className }: MenuPanelProps): JSX.Element {
  const hug = width === "hug";
  return (
    <div
      className={`${styles.panel}${hug ? ` ${styles.hug}` : ""}${className ? ` ${className}` : ""}`}
      style={hug ? undefined : { width }}
    >
      {items.map((item, index) => (
        <MenuRow key={index} {...item} />
      ))}
    </div>
  );
}
